import script from "./ProductEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEditView.vue?vue&type=script&setup=true&lang=js"

import "./ProductEditView.vue?vue&type=style&index=0&id=ed5f5d48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed5f5d48"]])

export default __exports__